import StoreModuleService from '../StoreModuleService';
import { initialState } from './state';
import Vue from 'vue';

export const SET_LOADING = 'SET_LOADING';
export const SET_PROCESSES = 'SET_PROCESSES';
export const SET_PROCESS = 'SET_PROCESS';
export const ADD_NODE = 'ADD_NODE';
export const ADD_LINK = 'ADD_LINK';
export const DELETE_LINK = 'DELETE_LINK';

const accessOrThrow = (processes, id) => {
	if (!(id in processes)) {
		throw new Error('unable to find process', id);
	}
	return processes[id];
};

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[SET_LOADING](state, value) {
		Vue.set(state, 'loading', value);
	},
	[SET_PROCESSES](state, processes) {
		Vue.set(state, 'processes', processes);
	},
	[SET_PROCESS](state, process) {
		if (!process.id) {
			throw new Error(`unable to get id from supplied process: ${process}`);
		}
		Vue.set(state.processes, process.id, process);
	},
	[ADD_NODE]: ({ processes }, { processId, node }) => accessOrThrow(processes, processId).nodes.push(node),
	[ADD_LINK]: ({ processes }, { processId, link }) => accessOrThrow(processes, processId).links.push(link),
	[DELETE_LINK]: ({ processes }, { processId, linkId }) => {
		const links = accessOrThrow(processes, processId).links;
		const index = links.findIndex(({ id }) => id === linkId);
		links.splice(index);
	},
};

export default mutations;
